var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('h1',[_c('i',{staticClass:"fas fa-home",attrs:{"aria-hidden":"true"}})]),_vm._v(" Help ")])
}]

export { render, staticRenderFns }